/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { StaticImage } from 'gatsby-plugin-image'
import React, { Fragment } from 'react'

import LinkComponent from '../LinkComponent/LinkComponent'
import {
  bacgroundImage,
  categoryColumn,
  categoryLinks,
  categoryTitle,
  changedLink,
  headerCategoriesData,
  headerCategoriesDataOpen,
  links,
  navContainer,
  normalLink,
  renderedItems,
  renderedItemsOpen,
  subCategoriesContainer,
  subCategoryColumn,
  treatmentList,
} from './NavComponent.module.css'

const NavComponent = ({
  activeTreatment,
  additionalClassName,
  changed,
  currentLang,
  defaultLang,
  extraClassName,
  footerSection,
  generallinkslabel,
  mainCategories,
  onClick,
  onMouseOver,
  opened,
  staticItemLinks,
  subCategories,
  treatmentsLinks,
}) => {
  const handleCategory = (category) => {
    if (category !== activeTreatment) {
      onClick(category)
    }
    onMouseOver(true)
  }

  const closeMenu = () => {
    onMouseOver(false)
  }
  return (
    <>
      <div className={`${navContainer} ${extraClassName}`}>
        {treatmentsLinks.map((category, index) => {
          let parsedCategory = category
          if (typeof category === 'string') {
            parsedCategory = JSON.parse(category)
          }
          return (
            <Fragment key={index}>
              <div className={categoryColumn}>
                {!footerSection && (
                  <div
                    onFocus={() => handleCategory(parsedCategory.title)}
                    onMouseOver={() => handleCategory(parsedCategory.title)}
                    role="presentation"
                  >
                    <span
                      className={`${links} ${additionalClassName} ${
                        changed ? changedLink : normalLink
                      }`}
                    >
                      {parsedCategory.title}
                    </span>
                  </div>
                )}
                {footerSection && (
                  <LinkComponent
                    className={`${links} ${
                      changed ? changedLink : normalLink
                    } ${additionalClassName}`}
                    src={parsedCategory.target}
                  >
                    {parsedCategory.title}
                  </LinkComponent>
                )}
                <div
                  className={`${renderedItems} ${
                    index !== 0 &&
                    opened &&
                    activeTreatment === parsedCategory.title
                      ? renderedItemsOpen
                      : ''
                  } ${
                    index === 0 &&
                    opened &&
                    activeTreatment === parsedCategory.title
                      ? subCategoriesContainer
                      : ''
                  }`}
                  onMouseLeave={() => closeMenu()}
                  role="presentation"
                >
                  {subCategories
                    .filter(
                      (item) => item.isundercategory === parsedCategory.title,
                    )
                    .map((item, idx) => {
                      const data = item.treatments.nodes
                      return (
                        <div key={idx} className={subCategoryColumn}>
                          <p className={`${categoryTitle}`}>{item.heading}</p>
                          <ul className={treatmentList}>
                            {data.map((treatment, subCategoryIdx) => {
                              const name =
                                treatment.pageType.name || treatment.title
                              const link = defaultLang
                                ? `/${treatment.pageType.uri}/`
                                : `/${currentLang}/${treatment.pageType.uri}/`
                              return (
                                <li key={subCategoryIdx}>
                                  <LinkComponent
                                    className={`${categoryLinks} ${changedLink}`}
                                    onClick={() => closeMenu()}
                                    src={link}
                                  >
                                    {name}
                                  </LinkComponent>
                                </li>
                              )
                            })}
                          </ul>
                        </div>
                      )
                    })}

                  {mainCategories
                    .filter((item) => item.heading === parsedCategory.title)
                    .map((item, idx) => {
                      const data = item.treatments.nodes
                      return (
                        <ul key={idx}>
                          {data.map((treatment, dataIndex) => {
                            const link = defaultLang
                              ? `/${treatment.pageType.uri}/`
                              : `/${currentLang}/${treatment.pageType.uri}/`
                            const name =
                              treatment.pageType.name || treatment.title
                            return (
                              <li key={dataIndex}>
                                <LinkComponent
                                  className={`${categoryLinks} ${changedLink}`}
                                  onClick={() => closeMenu()}
                                  src={link}
                                >
                                  {name}
                                </LinkComponent>
                              </li>
                            )
                          })}
                        </ul>
                      )
                    })}
                </div>
              </div>
            </Fragment>
          )
        })}
        {!footerSection && (
          <div className={categoryColumn}>
            <div
              onFocus={() => handleCategory(generallinkslabel)}
              onMouseOver={() => handleCategory(generallinkslabel)}
              role="presentation"
            >
              <span
                className={`${links} ${additionalClassName} ${
                  changed ? changedLink : normalLink
                }`}
              >
                {generallinkslabel}
              </span>
              <div
                className={`${renderedItems} ${
                  opened && activeTreatment === generallinkslabel
                    ? renderedItemsOpen
                    : ''
                }`}
                onMouseLeave={() => closeMenu()}
                role="presentation"
              >
                <ul>
                  {staticItemLinks.map((item, index) => {
                    const link = defaultLang
                      ? `/${item.pageType.uri}/`
                      : `/${currentLang}/${item.pageType.uri}/`
                    const name = item.pageType.name || item.title
                    return (
                      <li key={index}>
                        <LinkComponent
                          className={`${categoryLinks} ${changedLink}`}
                          onClick={() => closeMenu()}
                          src={link}
                        >
                          {name}
                        </LinkComponent>
                      </li>
                    )
                  })}
                </ul>
              </div>
            </div>
          </div>
        )}
        {footerSection &&
          staticItemLinks.map((item, index) => {
            const link = defaultLang
              ? `/${item.pageType.uri}/`
              : `/${currentLang}/${item.pageType.uri}/`
            const name = item.pageType.name || item.title
            return (
              <LinkComponent
                key={index}
                className={`${links} ${
                  changed ? changedLink : normalLink
                } ${additionalClassName}`}
                src={link}
              >
                {name}
              </LinkComponent>
            )
          })}
      </div>
      {!footerSection && (
        <div
          className={`${headerCategoriesData} ${
            opened ? headerCategoriesDataOpen : ''
          }`}
          role="presentation"
        >
          <StaticImage
            alt="background"
            className={bacgroundImage}
            formats={['auto', 'webp']}
            loading="eager"
            placeholder="none"
            quality="85"
            src="../../assets/images/headerbg.png"
          />
        </div>
      )}
    </>
  )
}

export default NavComponent
